import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../api';

const KEY = 'trucrunch_session_id';

function getSessionId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = 'ss_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, id);
  }
  return id;
}

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip auth callback
    if (location.hash?.includes('session_id=')) return;
    // Skip admin routes
    if (location.pathname.startsWith('/admin')) return;
    const sid = getSessionId();
    const path = location.pathname;
    api.post('/analytics/pageview', { session_id: sid, path }).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    const sid = getSessionId();
    const beat = () => {
      api.post('/analytics/heartbeat', { session_id: sid, path: location.pathname }).catch(() => {});
    };
    beat();
    const t = setInterval(beat, 25000);
    return () => clearInterval(t);
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
